import { render, staticRenderFns } from "./Experiencelist.vue?vue&type=template&id=2a722cf2&scoped=true&"
import script from "./Experiencelist.vue?vue&type=script&lang=js&"
export * from "./Experiencelist.vue?vue&type=script&lang=js&"
import style0 from "./Experiencelist.vue?vue&type=style&index=0&id=2a722cf2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a722cf2",
  null
  
)

export default component.exports